import { ReceptionService } from './../../business-services/reception.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditReceptionGuard  {
    constructor(
        private ReceptionBusinessService: ReceptionService,
        private router: Router
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        if (this.ReceptionBusinessService.userId) {
            return true;
        }
        return this.router.createUrlTree(['/user']);
    }
}
